import React from 'react';
import { Nav, Tab } from 'react-bootstrap';
import { LIST_VIEW_LABEL } from './agendaDay';

// Abas de Horários no celular: Diário (a Lista do dia) e Semana. O Tab.Container dá os papéis de aba, as setas do teclado e
// os ids (agenda-list-tab-day / agenda-list-tabpane-day); o painel é o da página (index.jsx)
const AgendaListTabs = ({ mode, onChange }) => (
  <Tab.Container id='agenda-list' activeKey={mode} onSelect={(key) => key && key !== mode && onChange(key)} unmountOnExit>
    <Nav variant='underline' fill className='agenda-list-tabs' aria-label={LIST_VIEW_LABEL}>
      <Nav.Link as='button' type='button' eventKey='day'>Diário</Nav.Link>
      <Nav.Link as='button' type='button' eventKey='week'>Semana</Nav.Link>
    </Nav>
  </Tab.Container>
);

export default AgendaListTabs;
